// extracted by mini-css-extract-plugin
module.exports = {"selector":"BucketSelector_selector__2Faa-","overline":"BucketSelector_overline__miia5","buckets":"BucketSelector_buckets__3yEyl"};